import { takeEvery, put, call, fork } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import {
  GET_REQUEST_FLOWS,
  getRequestFlowsSuccess,
  getRequestFlowsFailure,
  GET_REQUEST_LIST,
  getRequestListSuccess,
  getRequestListFailure,
  getRequestListEmpty,
  CANCEL_MY_REQUEST,
  cancelMyRequestSuccess,
  cancelMyRequestFailure,
  APPROVE_REQUEST,
  approveRequestSuccess,
  approveRequestFailure,
  REJECT_REQUEST,
  rejectRequestSuccess,
  rejectRequestFailure,
  GET_PENDING_REQUEST_LIST,
  getPendingRequestListFailure,
  getPendingRequestListSuccess
} from './actions';
import { getRequestMessageNum } from 'components/SideMenu/saga';
import { appendQueryParamsToUrl } from 'utils/portalUtilFunction';
import { appLogout } from 'app/actions';

export function* getRequestFlows(action) {
  try {
    // const requestFlowData = yield call(Client.getData, 'http://localhost:8099/api/v1/portal/flows');
    const requestFlowData = yield call(Client.getData, '/api/v1/portal/flows');

    yield put(getRequestFlowsSuccess(requestFlowData));
  } catch (error) {
    console.error(error);
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(getRequestFlowsFailure());
    }
  }
}


export function* getRequestList(action) {
  const data = action.payload;

  try {
    const requestListData = yield call(Client.getData, appendQueryParamsToUrl('/api/v1/portal/requests', data));
    if (undefined === requestListData || null === requestListData) {
      yield put(getRequestFlowsFailure());
      return;
    }

    if (requestListData.length === 0) {
      yield put(getRequestListEmpty());
      return;
    }

    yield put(getRequestListSuccess(requestListData));
  } catch (error) {
    console.error(error)
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(getRequestListFailure());
    }
  }
}

export function* getPendingRequestList(action) {
  const data = {"status":"CREATED", ...action.payload};

  try {
    const requestListData = yield call(Client.getData, appendQueryParamsToUrl('/api/v1/portal/requests', data));
    if (undefined === requestListData || null === requestListData) {
      yield put(getPendingRequestListFailure());
      return;
    }
    yield put(getPendingRequestListSuccess(requestListData));
  } catch (error) {
    console.error(error)
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(getPendingRequestListFailure());
    }
  }
}


export function* cancelMyRequest(action) {
  
  try {
    const requestId = action.payload.requestId;
    const result = yield call(Client.putData, '/api/v1/portal/requests/{0}/cancel', null, true, {'id':requestId});
    yield put(cancelMyRequestSuccess(result));
    yield call(getRequestMessageNum);
  } catch (error) {
    console.error('cancelMyRequest error', error)
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(cancelMyRequestFailure(error));
    }
  }
}

export function* approveRequest(action) {
  try {
    const { requestId, ...payload } = action.payload;
    const result = yield call(
      Client.putData,
      '/api/v1/portal/requests/{0}/approve',
      payload,
      true,
      { id: requestId }
    );
    yield put(approveRequestSuccess(result));
    yield call(getRequestMessageNum);
  } catch (error) {
    console.error('approveRequest error', error);
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(approveRequestFailure(error));
    }
  }
}

export function* rejectRequest(action) {
  try {
    const { requestId, ...payload } = action.payload;
    const result = yield call(
      Client.putData,
      '/api/v1/portal/requests/{0}/reject',
      payload,
      true,
      { id: requestId }
    );
    yield put(rejectRequestSuccess(result));
    yield call(getRequestMessageNum);
  } catch (error) {
    console.error('rejectRequest error', error);
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(rejectRequestFailure(error));
    }
  }
}

function* watchGetRequestFlows() {
  yield takeEvery(GET_REQUEST_FLOWS, getRequestFlows);
  yield takeEvery(GET_REQUEST_LIST, getRequestList);
  yield takeEvery(GET_PENDING_REQUEST_LIST, getPendingRequestList);
  yield takeEvery(CANCEL_MY_REQUEST, cancelMyRequest);
  yield takeEvery(APPROVE_REQUEST, approveRequest);
  yield takeEvery(REJECT_REQUEST, rejectRequest);
}

export function* requestFlowSaga() {
  yield fork(watchGetRequestFlows);
}